import { APP_BASE_URL, MARKETING_BASE_URL } from "@/lib/constants/routes";

export interface NavigationItem {
    label: string;
    href: string;
    description?: string;
    badge?: string;
    icon?: string;
    children?: NavigationItem[];
    sections?: NavigationSection[];
}

export interface NavigationSection {
    title?: string;
    items: NavigationItem[];
}

export const mainNavigation: NavigationItem[] = [
    {
        label: "Home",
        href: MARKETING_BASE_URL,
        description: "Back to homepage",
    },
    {
        label: "Curriculum",
        href: `${MARKETING_BASE_URL}/curriculum`,
        description: "See how we align with your curriculum",
        sections: [
            {
                title: "Core Curriculum",
                items: [
                    { label: "Saxon Math", href: `${MARKETING_BASE_URL}/curriculum/saxon-math` },
                    {
                        label: "Singapore Math-Dimensions",
                        href: `${MARKETING_BASE_URL}/curriculum/singapore-math-dimensions`,
                    },
                    {
                        label: "Saxon vs. Singapore Comparison",
                        href: `${MARKETING_BASE_URL}/curriculum/comparison`,
                    },
                ],
            },
            {
                title: "Supplementary",
                items: [
                    {
                        label: "Drill Team",
                        href: `${MARKETING_BASE_URL}/drill-team`,
                        description: "Timed math drills for fluency",
                    },
                    {
                        label: "Learning Lab",
                        href: `${MARKETING_BASE_URL}/learning-lab`,
                        description: "Extra practice and review",
                    },
                ],
            },
        ],
    },
    {
        label: "Pricing",
        href: `${MARKETING_BASE_URL}/pricing`,
        description: "Choose the plan that works for you",
    },
    {
        label: "More",
        href: "#",
        description: "Additional resources and information",
        sections: [
            {
                title: "Learning & Resources",
                items: [
                    {
                        label: "Placement Tests",
                        href: `${MARKETING_BASE_URL}/placement-tests`,
                        description: "Find the right starting point",
                    },
                    { label: "Textbooks", href: `${MARKETING_BASE_URL}/textbooks` },
                    { label: "Blog", href: `${MARKETING_BASE_URL}/blog` },
                    { label: "Shop", href: "https://store.nicolethemathlady.com/" },
                    { label: "Testimonials", href: `${MARKETING_BASE_URL}/testimonials` },
                ],
            },

            {
                title: "Company",
                items: [
                    { label: "About Us", href: `${MARKETING_BASE_URL}/about` },
                    { label: "Careers", href: `${MARKETING_BASE_URL}/careers`, badge: "We're hiring!" },
                    { label: "Affiliates", href: `${MARKETING_BASE_URL}/affiliates` },
                ],
            },
            {
                title: "Help & Support",
                items: [
                    { label: "Help Center", href: `${MARKETING_BASE_URL}/faqs` },
                    { label: "Contact Us", href: `${MARKETING_BASE_URL}/contact` },
                ],
            },
        ],
    },
];

export const loginOptions: NavigationItem[] = [
    {
        label: "Student",
        href: `${APP_BASE_URL}/login/student`,
        icon: "GraduationCap",
    },
    {
        label: "Parent",
        href: `${APP_BASE_URL}/login/parent`,
        icon: "Users",
    },
    {
        label: "School Teacher",
        href: `${APP_BASE_URL}/login/teacher`,
        icon: "BookOpen",
    },
    {
        label: "School Admin",
        href: `${APP_BASE_URL}/login/admin`,
        icon: "Settings",
    },
    {
        label: "School PO Processor",
        href: `${APP_BASE_URL}/login/po-processor`,
        icon: "FileCog",
    },
    {
        label: "Affiliates",
        href: `${APP_BASE_URL}/affiliate-auth`,
        icon: "Settings",
    },
];

export const footerNavigation = {
    product: [
        { label: "Features", href: `${MARKETING_BASE_URL}/features` },
        { label: "Curriculum", href: `${MARKETING_BASE_URL}/curriculum` },
        { label: "Pricing", href: `${MARKETING_BASE_URL}/pricing` },
        { label: "Free Trial", href: `${MARKETING_BASE_URL}/trial` },
    ],
    company: [
        { label: "About Us", href: `${MARKETING_BASE_URL}/about` },
        { label: "Our Team", href: `${MARKETING_BASE_URL}/about/team` },
        { label: "Careers", href: `${MARKETING_BASE_URL}/about/careers` },
        { label: "Press", href: `${MARKETING_BASE_URL}/about/press` },
    ],
    resources: [
        { label: "Help Center", href: `${MARKETING_BASE_URL}/help` },
        { label: "Blog", href: `${MARKETING_BASE_URL}/blog` },
        { label: "Webinars", href: `${MARKETING_BASE_URL}/webinars` },
        { label: "Case Studies", href: `${MARKETING_BASE_URL}/case-studies` },
    ],
    legal: [
        { label: "Privacy Policy", href: `${MARKETING_BASE_URL}/legal/privacy` },
        { label: "Terms of Service", href: `${MARKETING_BASE_URL}/legal/terms` },
        { label: "Cookie Policy", href: `${MARKETING_BASE_URL}/legal/cookies` },
        { label: "COPPA Compliance", href: `${MARKETING_BASE_URL}/legal/coppa` },
    ],
};
